/**
 * Created by amir on 12/20/17.
 */

export default class UiHelper {

    constructor() {
        this.currentShowenModalName = [];
    }

    showModal(modalName) {
        this._addModal(modalName);
        let modalId = '#' + modalName;
        $(modalId).modal('show');
    }

    _addModal(modalName) {
        let isModalDoesntExist = this.currentShowenModalName.indexOf(modalName) === -1;
        if (isModalDoesntExist) {
            this.currentShowenModalName.push(modalName);
        }
    }

    _removeModal(modalName) {
        this.currentShowenModalName = _.pull(this.currentShowenModalName, modalName);
    }

    closeModal(modalName){

        let modalId = '#' + modalName;

        try {
            $(modalId).off('hide.bs.modal.prevent');
            $(modalId).removeClass('fade');
            $(modalId).modal('hide');
        }
        catch (err) {
        }
        this._removeModal(modalName);
    }

    closeModals() {

        for (let modalName of this.currentShowenModalName) {
            this.closeModal(modalName);
        }

        this.resetModals();
    }

    resetModals() {
        this.currentShowenModalName = [];
    }
}



/** WEBPACK FOOTER **
 ** ./src/services/app/ui.helper.service.js
 **/